import { isEmpty } from 'lodash'
import { bookingById, bookingByProperty, bookingByLegacyBooking } from '../service/booking'

export const loadBookingByLegacyId = (state, dispatch) => async (bookingLegacyId) => {
  if (isEmpty(state.booking) || !state.booking || bookingLegacyId !== state.booking.booking_legacy_id) {
    try {
      const booking = await bookingByLegacyBooking(bookingLegacyId)
      dispatch({ type: 'SET_BOOKING', payload: booking })
      return { booking }
    } catch (e) {
      console.error(e)
      if (e && e.response && e.response.status) {
        return { error: e.response.status }
      }
    }
  } else {
    return { booking: state.booking }
  }
}

export const loadBookingById = (state, dispatch) => async (bookingId) => {
  if (isEmpty(state.booking) || !state.booking || bookingId !== state.booking.id) {
    try {
      const booking = await bookingById(bookingId)
      dispatch({ type: 'SET_BOOKING', payload: booking })
      return { booking }
    } catch (e) {
      console.error(e)
      if (e && e.response && e.response.status) {
        return { error: e.response.status }
      }
    }
  } else {
    return { booking: state.booking }
  }
}

export const loadBookingByPropertyId = (state, dispatch) => async (propertyId) => {
  if (isEmpty(state.booking) || !state.booking || propertyId !== state.booking.property_id) {
    try {
      const booking = await bookingByProperty(propertyId)
      dispatch({ type: 'SET_BOOKING', payload: booking })
      return { booking }
    } catch (e) {
      console.error(e)
      if (e && e.response && e.response.status) {
        return { error: e.response.status }
      }
    }
  } else {
    return { booking: state.booking }
  }
}
